import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import { Button } from "../../../common/Button/Button";
import moment from "moment";
import { NavButtons } from "../../../common/NavButtons/NavButtons";
import NotesTrailDropdown from "./NotesTrailDropdown";
import ConfirmationModal from "./ConfirmationModal";
import Checkbox from "../../../common/Checkbox/Checkbox";
import Select from "react-select";
import api from "../../../utils/api";
import { useState } from "react";
import CentralizedNotesModal from "../Handholder/CentralizedNotesModal";
import CentralizedSMSLogModal from "../Handholder/CentralizedSMSLogModel";
import ESPSMSTrail from "../../../containers/EServicePartnerServiceRequests/ESPSMSTrail";
import SMSTrailModal from "../Handholder/SMSTrailModal";

export default function NotesServiceFacilitatorViewModel(props) {


	const [selectedCustomerEmailForNotes, setselectedCustomerEmailForNotes] = useState(null);
	const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	const toggleViewAllNotesModal = (email) => {
		setselectedCustomerEmailForNotes(email);
		setShowViewAllNotesModal(!showViewAllNotesModal);
	};
	

	const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	const toggleViewAllSMSModal = (email) => {
		setselectedCustomerEmailForNotes(email);
		setShowViewAllSMSModal(!showViewAllSMSModal);
	};



	const [showSMSTrailModal, setShowSMSTrailModal] = useState(false);
	const toggleSMSTrailModal = () => {
		setShowSMSTrailModal(!showSMSTrailModal);
	};

	// const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	// const toggleViewAllNotesModal = () => {
	// 	setShowViewAllNotesModal(!showViewAllNotesModal);
	// };

	// const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	// const toggleViewAllSMSModal = () => {
	// 	setShowViewAllSMSModal(!showViewAllSMSModal);
	// };

	return (
		<Modal 
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
			className="conv-mdl-wd"
		>
			<ModalContent>
			<div className="p-2 modal-headers-bar">
					<span>Notes</span>
					<button
						type="button"
						className="close"
						aria-label="Close"
						onClick={() => props.toggleModal(!props.isOpen)}
					>
						<X
							style={{ pointerEvents: "none" }}
							color="white"
						/>
					</button>
				</div>
				<div className="">
					{" "}
					{/* <div className="notesHistory">{renderNotesTrail()}</div> */}
					{
						// props.service&&props.service.refExternalServicePartner?
						// (
						// 	<>
						// 		<div className="spm-notes-details">
						// 		<label style={{float:"left",marginRight:"5px",marginTop:"5px"}}>
						// 		Need to talk to SP
						// 		</label>
						// 		<Select
						// 			//placeholder="Select Need to talk to SP"
						// 			options={props.needToTalkToSPOptions}
						// 			onChange={props.setSelectedNeedToTalkToSPOption}
						// 			value={props.selectedNeedToTalkToSPOption}
						// 		></Select>
						// 		</div>
						// 		{/*<Button className="sp-inline-button"
						// 		onClick={props.onUpdateNeedToTalkToSPFlag}>
						// 			Save
						// 		</Button>*/}
						// 		<div style={{clear:"both"}}></div>		
						// 	</>	
						// ):
						("")
					}
                <div className="m-3">
                    <div className="mt-2 spled-container ">
						<label>Follow up on<span>*</span></label>
						<br></br>
						<div className="width-100">   
						<ReactDatePicker 
                                dateFormat="dd/MM/yyyy"
                                selected={props.notesDetails &&
									props.notesDetails.dtFollowupOn
										? new Date(props.notesDetails.dtFollowupOn)
										: null}
                                onChange={(date) =>
                                    props.onInputChange("dtFollowupOn", date)
                                }
								minDate={new Date()}
                                placeholderText="Follow Up On"
								 
                            />
							</div>
						{/* <ReactDatePicker
							dateFormat="dd/MM/yyyy"
							selected={
								props.notesDetails &&
								props.notesDetails.dtFollowupOn
									? new Date(props.notesDetails.dtFollowupOn)
									: null
							}
							onChange={(date) =>
								props.onInputChange("dtFollowupOn", date)
							}
							minDate={new Date()}
						/> */}
					</div>
					<div className="mt-2 ">
						<label>Followup Actions<span>*</span></label>
						
						<div>
							<textarea
								name="sFollowupAction"
								className="w-100 form-control rounded"
								value={
									props.notesDetails
										? props.notesDetails.sFollowupAction
										: ""
								}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
							/>
						</div>
					</div>
					
					<div className="mt-2 mb-2 ">
						<label>
							Notes<span>*</span>
						</label>
						<div>
							<textarea
								className="w-100 form-control rounded"
								name="sNotes"
								value={
									props.notesDetails
										? props.notesDetails.sNotes
										: ""
								}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
							/>
						</div>
					</div>
					<div className="mb-2">
						<Checkbox
							label="Complete"
							name="bHandled"
							id="bHandled"
							value={
								props.notesDetails
									? props.notesDetails.bHandled
									: false
							}
							checked={
								props.notesDetails
									? props.notesDetails.bHandled
									: false
							}
							onChange={({ target: { name, checked } }) =>
								props.onInputChange(name, checked)
							}
						></Checkbox>
					</div>


					<div className="flex">
						 
						 <a className="con-cursor-pointer" target="_blank"
							onClick={()=>{toggleViewAllNotesModal(props.notesDetails&&props.notesDetails.refService.sEmailAddress||"")}}

							>
						<span className="label-link conv-ml30 conv-mr10"> All Notes</span>     
						</a>
						
						{/* <ESPSMSTrail 
							nResourceInstanceId={props.notesDetails&&props.notesDetails.nResourceInstanceId||""}
						 	isFromSPM={true}	 
						/> */}

						<a className="con-cursor-pointer" target="_blank"
							onClick={toggleSMSTrailModal}
							>
						<span className="label-link conv-ml10">SMS Trail</span>     
						</a>

						<a className="con-cursor-pointer" target="_blank"
							onClick={()=>{toggleViewAllSMSModal(props.notesDetails&&props.notesDetails.refService.sEmailAddress||"")}}
							>
						<span className="label-link conv-ml10"> All SMS</span>     
						</a>
						
						{/* <Button 
							onClick={toggleViewAllSMSModal}
							style={{float:"left"}}
							>
							 All SMS
						</Button> */}
					</div>
					</div>

					<div className="flex auditss-body">
						 	 
							<button
								type="button" 
								className="spms-cons-btns-bordered-filter conv-mr40 conv-ml30 assgn-width"
								onClick={props.toggleModal}
							>
								Cancel
							</button>
							 

							{/* <Button onClick={props.onSaveNotesDetails}>
								Save
							</Button> */}
							 
							<button className="lpms-cons-btns-filled conv-mr40 assgn-width "
                            onClick={props.onSaveNotesDetails} >
                            Save
                        	</button>			
						 
					</div>


				</div>
				<ConfirmationModal
					message="Closing the modal will discard your changes. Continue?"
					isOpen={props.isOpenConfirmationModal}
					toggleModal={props.toggleConfirmationModal}
					changeState={props.confirmChangeNotes}
				/>
			</ModalContent>

			{
				showViewAllNotesModal&&
				(
					<CentralizedNotesModal
						isOpen={showViewAllNotesModal}
						toggleModal={toggleViewAllNotesModal}
						sEmailAddress={selectedCustomerEmailForNotes||""}
					 
					>
					</CentralizedNotesModal>
				)
			}
			{
				showViewAllSMSModal&&
				(
					<CentralizedSMSLogModal
						isOpen={showViewAllSMSModal}
						toggleModal={toggleViewAllSMSModal}
						sEmailAddress={selectedCustomerEmailForNotes||""}
					>
					</CentralizedSMSLogModal>
				)
			}

{
					showSMSTrailModal&&props.notesDetails&&
					(
						<SMSTrailModal
							isOpen={showSMSTrailModal}
							toggleModal={toggleSMSTrailModal}
							nResourceInstanceId={props.notesDetails.refService.nResourceInstanceId}
						/>
					)
				}
		</Modal>
	);
}
